<ng-container *ngIf="!logOut && !isAuthRoute && !isLoginRoute">
  <app-layout></app-layout>
</ng-container>
<ng-container *ngIf="logOut || isAuthRoute || isLoginRoute">
  <router-outlet></router-outlet>
</ng-container>

<p-toast key="base-toast"></p-toast>
<p-toast
  key="root-msg"
  position="bottom-center"
  [showTransformOptions]="'translateY(100%)'"
  [showTransitionOptions]="'200ms'"
  [hideTransitionOptions]="'200ms'"
  [showTransformOptions]="'translateX(0%)'"
/>
<p-confirmDialog />
